<template>
  <div>
    <!-- tab栏 -->
    <van-sticky>
      <van-tabs @click="onClickOnlyOne"
        swipe-threshold="3"
        v-if="TitleList.length == '1'"
        color="#ed664e"
        title-active-color="#ed664e">
        <van-tab v-for="item in TitleList[0].Children"
          :key="item.AKId"
          :name="item.AKId"
          :title="item.Name">
        </van-tab>
      </van-tabs>
      <van-tabs @click="topClick"
        v-else
        type="card"
        color="#31D984"
        swipe-threshold="3">
        <van-tab v-for="item in TitleList"
          :key="item.AKId"
          :name="item.AKId"
          :title="item.Name">
          <van-tabs v-if="item.Children.length != '0'"
            v-model="activeName"
            swipe-threshold="3"
            @click="onClick"
            color="#ed664e"
            title-active-color="#ed664e">
            <van-tab v-for="item in item.Children"
              :key="item.AKId"
              :name="item.AKId"
              :title="item.Name">

            </van-tab>
          </van-tabs>
        </van-tab>
      </van-tabs>
    </van-sticky>

    <div class="information">
      <!-- 全部 -->
      <div class="center borderClass"
        v-for="item in list"
        :key="item.index">
        <router-link :to="'/partymember/activity/' + item.AId">

          <div class="Content">
            <div style="display: inline-block; width: 33%"
              class="ContentA">
              <img v-if="item.AImgUrl"
                style="border-radius:5px;"
                :src="item.AImgUrl"
                alt="" />
            </div>
            <div style="display: inline-block; width: 63%"
              class="ContentB">
              <div class="centerTitle van-ellipsis--l2">
                {{ item.Title }}
              </div>
            </div>
            <span class="centertime"
              style="float: right; margin-top: -15px;color:black;">{{
              item.AuditTime
            }}</span>
          </div>
        </router-link>
      </div>
      <!-- 没有更多数据了 -->
      <div v-if="hidden"
        class="hidden">───── 没有更多数据了 ─────</div>
    </div>

  </div>
</template>
<script>
import { setOpenId, getOpenId } from "@/utils/auth";
import { WeGetMyActivityPage, WeGetPBActivityPage } from "@/api/RealInfo";
export default {
  data () {
    return {
      activeName: "",
      akId: 0, //tab栏
      list: {}, //资讯列表
      listfrom: {
        page: 1,
        limit: 10,
        PAKind: 2,
      }, //查询传参
      hidden: true, //没有更多数据了
      TitleList: [],
    };
  },
  methods: {
    // 活动分类
    getPBActivityList: function () {
      WeGetPBActivityPage({ PAKind: 2, }).then((res) => {
        this.TitleList = res.data.data;
        if (this.TitleList[0].Children != '0') {
          this.listfrom.akId = this.TitleList[0].Children[0].AKId
        } else {
          this.listfrom.akId = this.TitleList[0].AKId
        }
        this.getList();
      })
    },
    // 获取分页列表
    getList () {
      WeGetMyActivityPage(this.listfrom)
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.count == 0) {
              this.list = {};
            } else {
              this.list = res.data.data;
              for (var i = 0; i < this.list.length; i++) {
                if (this.list[i].AImgUrl == "") {
                  this.list[i].AImgUrl =
                    "http://cuiyunapi.dexian.ren//upload/images/2021/7/873b94ff-81d.png";
                }
              }
            }
          }
        })
        .catch(() => { });
    },
    topClick: function (name, title) {
      for (let index = 0; index < this.TitleList.length; index++) {
        const element = this.TitleList[index];
        if (element.Children.length != '0') {
          if (element.AKId == name) {
            this.listfrom.akId = element.Children[0].AKId
            this.activeName = element.Children[0].AKId
            this.getList()
          } else {
            this.listfrom.akId = element.AKId
            this.getList()
          }
        }

      }
    },
    // tab点击切换事件
    onClick (name, title) {
      this.list = []
      this.listfrom.akId = name
      this.listfrom.page = 1
      this.getList()
    },
    onClickOnlyOne (name, title) {
      console.log(123123);
      console.log(name);
      this.list = []
      this.listfrom.akId = name
      this.listfrom.page = 1
      this.getList()
    },
  },
  mounted () {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    this.getPBActivityList()
    // this.getList();
  },
};
</script>
<style scoped>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.information {
  width: 95%;
  margin: auto;
}
.borderClass {
  padding: 0;
  box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%);
}
.borderClass .Content {
  padding: 8px;
  margin-top: 10px;
}
/deep/.van-tabs__nav--card {
  box-sizing: border-box;
  height: 30px;
  margin: 0;
  color: #fff;
  border-radius: 2px;
  padding: 0;
}
</style>
